import Icon from "../../../../../assets/spaceicons/PDFViewer.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { DEFAULT_SIZES } from "../../../layout/constants";
import {
  ElementLayout,
  DEFAULT_ELEMENT_LAYOUT_OPTIONS,
  OverflowOption
} from "../../../layout/util";
import { commonComponentReducer } from "../../../SpaceConfig/SpaceConfigContext/useSpaceConfig/reducer";

import Config from "./Config";
import errorSelector from "./Config/errorSelector";
import SpaceDocumentViewer from "./SpaceDocumentViewer";
import {
  SpaceDocumentViewerComponent,
  DocumentViewerConfigState,
  SpaceDocumentViewerProperties
} from "./types";

const pkg: SpaceComponentPackage<
  SpaceDocumentViewerProperties,
  SpaceDocumentViewerComponent,
  DocumentViewerConfigState
> = {
  type: "DOCUMENT_VIEWER",
  displayName: "PDF Viewer",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>(["SPACE", "FLEX_BOX"]),
  Component: SpaceDocumentViewer,
  ConfigurationComponent: Config,
  ensureComponent: component => component,
  componentConfigReducer: commonComponentReducer,
  getSchema: () => [],
  defaultElementLayout: new ElementLayout({
    width: DEFAULT_SIZES.TALL.width,
    height: DEFAULT_SIZES.TALL.height,
    snapToGrid: true
  }),
  elementLayoutOptions: {
    ...DEFAULT_ELEMENT_LAYOUT_OPTIONS,
    overflow: [OverflowOption.HIDDEN]
  },
  allowSelfBinding: false,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Content],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
